module.exports = __webpack_public_path__ + "img/robot_4.6a4c567a.png";